<script setup lang="ts">
import ApplicationStepHeader from '@/components/common/application-step-header.vue';
import GoodsClassList from './goods-class-list.vue';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import RouteName from '@/router/route-name';
import { storeToRefs } from 'pinia';
import { useTrademarkStore } from '@/store/mark';
import { useOwnerStore } from '@/store/owner';
import { useProductStore } from '@/store/good';
import useCountry from '@/composables/countryDependable';

const productStore = useProductStore();
const { goods, classes } = storeToRefs(productStore);
const trademarkStore = useTrademarkStore();
const { trademarkWord, trademarkImageUrl } = storeToRefs(trademarkStore);
const ownerStore = useOwnerStore();
const { ownerDetails } = storeToRefs(ownerStore);
const router = useRouter();
const country = useCountry();

const formattedAddress = computed(() => {
    const { address, suburb, stateRegion, postCode, country } = ownerDetails.value;
    let parts = [address, suburb, stateRegion, postCode].filter(Boolean);
    if (country) parts.push(country);
    return parts.join(', ');
});

</script>

<template>
    <StfCard>
        <template #title>
            <ApplicationStepHeader title="Summary" :help="false">
                <template #right>
                    <a href="javascript:void(0)" @click="router.push({ name: RouteName.APPLICATION_PROCESS })">Edit</a>
                </template>
            </ApplicationStepHeader>
        </template>
        <template #content>
            <div gap="0">
                <b>Country:</b>
                <span class="mt-0 ml-1">{{ country.nameFull }}</span>
            </div>
            <div gap="0">
                <b>Trademark:</b>
                <span v-if="trademarkWord" class="mt-0 ml-1">{{ trademarkWord }}</span>
                <div v-else-if="trademarkImageUrl" class="m-2 trademark-image-container">
                    <img :src="trademarkImageUrl" alt="Trademark" class="trademark-image" />
                </div>
            </div>
        
            <GoodsClassList :classes="classes" :goods="goods" />

            <StfRow gap="0" class="mt-2">
                <StfCol col="12" colDesktop="6" class="pr-1">
                    <div><b>Owner Name:</b> <span>{{ ownerDetails.ownerNames.join(', ') }}</span></div>
                    <div v-if="ownerDetails.businessNumber"><b>ABN/ACN:</b> <span>{{ ownerDetails.businessNumber }}</span></div>
                    <div><b>Address:</b> <span>{{ formattedAddress }}</span></div>
                </StfCol>
                <StfCol col="12" colDesktop="6">
                    <div><b>Email:</b> <span>{{ ownerDetails.email }}</span></div>
                    <div><b>Phone Number:</b> <span>{{ ownerDetails.phone }}</span></div>
                </StfCol>
            </StfRow>

        </template>
    </StfCard>
</template>

<style scoped>
.trademark-image-container {
  background-color: #E5E5E5;
  display: inline-block;
  padding: 8px;
  border-radius: 4px;
}

.trademark-image {
  max-height: 60px;
  max-width: 200px;
  object-fit: contain;
}

:deep(.stf-card-content) {
  line-height: 1.3;
}
</style>

